var irreducible = require('./irreducible');
var isBoolean = require('./isBoolean');

module.exports = irreducible('Boolean', isBoolean);



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/Boolean.js
 ** module id = 493
 ** module chunks = 0
 **/